export default "/images/f9cae270fc076ce9a4905dd6c025ca67.avif";